import React from 'react'
import {FileUpload} from '../features/File'
export default function Gantt() {
  return (
    <FileUpload />
  )
}
